import { DEMO_CV_DATA } from '~/constants/demoCv'
import type { PdfTemplateId } from '~/constants/cvTemplates'

/**
 * The public examples the template gallery links to for the templates that
 * came after the hand-made ones (components/homepage/TemplateShowcase.vue).
 *
 * supabase/migrations/20260925_template_examples.sql creates these rows under
 * info@inmyresume.com. Until it has run (or if the rows are deleted) the
 * public pages fall back to this: the sample from constants/demoCv in the
 * row's template, so a gallery card never opens on "CV not found". Once the
 * row exists the database wins, and the owner can edit it like any other CV.
 */
export const SHOWCASE_CVS: Record<string, PdfTemplateId> = {
  '5a04b875-12b6-4e94-ad77-a91fdf756d5b': 'basic',
  'e9b4497e-6f58-4aca-bfa0-7634b38407cc': 'ats',
}

export function isShowcaseCv(id: unknown): id is string {
  return typeof id === 'string' && id in SHOWCASE_CVS
}

/** The fallback row, shaped like the cv_requests columns the public pages select. */
export function showcaseCvRow(id: string) {
  const template = SHOWCASE_CVS[id]
  if (!template) return null
  return {
    id,
    parsed_data: { ...DEMO_CV_DATA, template },
    created_at: '2026-09-25T00:00:00Z',
    is_public: true,
    user_id: null,
    template,
    business_web_template: 'sofax' as const,
  }
}
